exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-action-page-modal .action-page-modal-icon{height:1.75rem;display:flex;align-items:center}.fts-action-page-modal .action-page-modal-container{height:100%}.fts-action-page-modal .action-page-modal-content{padding:0;overflow:hidden!important}.fts-action-page-modal iframe{width:100%;height:100%}", ""]);

// exports
